module.exports = __webpack_public_path__ + "static/img/beamClean_total.fe1f470.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/beamClean_total.png
// module id = NN3Z
// module chunks = 1